const BASE = import.meta.env.VITE_SALE_API_URL ?? 'http://localhost:8003';

export interface StancerVerifyResponse {
  status: 'paid' | 'pending' | 'failed' | 'expired' | 'unknown' | 'no_session';
  changed: boolean;
  payment_status: string;
  online_status: string;
  restaurant_uuid?: string;
}

export interface StancerVerifyAuth {
  orderAccessToken?: string | null;
  consumerToken?: string | null;
}

export async function verifyStancerPayment(
  orderUuid: string,
  auth: StancerVerifyAuth = {},
): Promise<StancerVerifyResponse> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (auth.consumerToken) headers.Authorization = `Token ${auth.consumerToken}`;
  const response = await fetch(`${BASE}/sale/payments/stancer/verify/${orderUuid}/`, {
    method: 'POST',
    headers,
    body: JSON.stringify(auth.orderAccessToken ? { access_token: auth.orderAccessToken } : {}),
  });
  if (!response.ok) throw new Error(`stancer verify failed: ${response.status}`);
  return (await response.json()) as StancerVerifyResponse;
}
